module.exports = __webpack_public_path__ + "img/service-tab-img6.e747639b.png";